import {LoginPayload, UserGenericPayload} from "./user-generic-payload";

export class LoginWithPasswordPayload extends LoginPayload {
  constructor(username: string, private rememberMe: boolean, private password: string) {
    super(username);
  }

  getPayload(): UserPasswordPayload {
    return {username: this.username, password: this.password, rememberMe: this.rememberMe};
  }
}

interface UserPasswordPayload extends UserGenericPayload {
  password: string;
}
